import {req, reqJson} from './axiosFun';

/**
 * 跑腿订单管理
 **/
//查询
export const runErrandsPage = (params) => {
  return reqJson("post", "/api/runErrands/queryByAdminPage", params)
};
//删除
export const runErrandsDelete = (params) => {
  return reqJson("post", "/api/runErrands/delete/" + params.id)
};
//发布人取消
export const runErrandsCancel = (params) => {
  return reqJson("put", "/api/runErrands/cancel/" + params.id)
};
//接单人取消
export const runErrandsReceiveCancel = (params) => {
  return reqJson("put", "/api/runErrands/receiveCancel/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/runErrandsMG.js